import { dashboardNepali, dashboardEnglish } from "./dashboard";
import { commonNepali, commonEnglish } from "./common";
import { projectsNepali, projectsEnglish } from "./projects";
import { aboutNepali, aboutEnglish } from "./about";
import { contactNepali, contactEnglish } from "./contact";
import { feedbackNepali, feedbackEnglish } from "./feedback";
import { detailNepali, detailEnglish } from "./detail";
import { number, currency, formattedCurrency, neNumberToEn } from "./number";
import { getMonthName, date, nepaliFormattedDate, getAllMonths } from "./month";
import { helpTextEnglish, helpTextNepali } from "./helpText";
import { glossaryEnglish, glossaryNepali } from "./glossary";
import { howToUseEnglish, howToUseNepali } from "./howTouse";

const commonLocalization = {
    en: commonEnglish,
    np: commonNepali
};

const dashboardLocalization = {
    en: dashboardEnglish,
    np: dashboardNepali
};

const projectsLocalization = {
    en: projectsEnglish,
    np: projectsNepali
};

const aboutLocalization = {
    en: aboutEnglish,
    np: aboutNepali
};

const contactLocalization = {
    en: contactEnglish,
    np: contactNepali
};

const detailLocalization = {
    en: detailEnglish,
    np: detailNepali
};

const feedbackLocalization = {
    en: feedbackEnglish,
    np: feedbackNepali
};

const helpTextLocalization = {
    en: helpTextEnglish,
    np: helpTextNepali
};

const glossaryLocalization = {
    en: glossaryEnglish,
    np: glossaryNepali
};

const howToUseLocalization = {
    en: howToUseEnglish,
    np: howToUseNepali
};

// const privacyPolicyLocalization = {
//   en: privacyPolicyEnglish,
//   np: privacyPolicyeNepali
// };

export {
    commonLocalization,
    dashboardLocalization,
    projectsLocalization,
    aboutLocalization,
    contactLocalization,
    detailLocalization,
    feedbackLocalization,
    number,
    neNumberToEn,
    currency,
    getMonthName,
    date,
    nepaliFormattedDate,
    getAllMonths,
    formattedCurrency,
    helpTextLocalization,
    glossaryLocalization,
    howToUseLocalization
    // privacyPolicyLocalization
};



// WEBPACK FOOTER //
// ./src/localization/index.js